import {formatarDateTime} from './formatarDateTime'
import cdCurrency from './cdCurrency'
import azDate from './azDate'

export default {
    install(Vue) {
        Vue.filter('DateTimeFormater', formatarDateTime)
        Vue.filter('cdCurrency', cdCurrency)
        Vue.filter('az-date', azDate)
    }
}